import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { getSchemaAttrs, nodeToDOM } from '@common/util/schema';
import { NodeSpec } from 'prosemirror-model';

export class MadCapProxySchemaPlugin extends SchemaPlugin {
  nodes = {
    madcapbodyproxy: {
      group: 'block',
      attrs: {
        'MadCap:autonum': { default: undefined }
      },
      parseDOM: [{
        tag: 'MadCap\\:bodyProxy',
        getAttrs(dom: HTMLElement) {
          return getSchemaAttrs(dom, ['MadCap:autonum']);
        }
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:bodyProxy',
      isTagNameBox: true,
      isVoid: true
    },

    madcapbreadcrumbsproxy: {
      group: 'block',
      attrs: {
        'MadCap:autonum': { default: undefined }
      },
      parseDOM: [{
        tag: 'MadCap\\:breadcrumbsProxy',
        getAttrs(dom: HTMLElement) {
          return getSchemaAttrs(dom, ['MadCap:autonum']);
        }
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:breadcrumbsProxy',
      isTagNameBox: true,
      isVoid: true
    },

    madcapcentralaccountproxy: {
      group: 'block',
      attrs: {
        'data-mc-skin': { default: undefined }
      },
      parseDOM: [{
        tag: 'MadCap\\:centralAccountProxy',
        getAttrs(dom: HTMLElement) {
          return getSchemaAttrs(dom, ['data-mc-skin']);
        }
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:centralAccountProxy',
      isTagNameBox: true,
      isVoid: true
    },

    madcaptopictoolbarproxy: {
      group: 'block',
      attrs: {
        'data-mc-skin': { default: undefined },
        'MadCap:autonum': { default: undefined }
      },
      parseDOM: [{
        tag: 'MadCap\\:topicToolbarProxy',
        getAttrs(dom: HTMLElement) {
          return getSchemaAttrs(dom, ['MadCap:autonum', 'data-mc-skin']);
        }
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:topicToolbarProxy',
      isTagNameBox: true,
      isVoid: true
    },

    madcapminitocproxy: {
      group: 'block',
      attrs: {
        'MadCap:autonum': { default: undefined }
      },
      parseDOM: [{
        tag: 'MadCap\\:miniTocProxy',
        getAttrs(dom: HTMLElement) {
          return getSchemaAttrs(dom, ['MadCap:autonum']);
        }
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:miniTocProxy',
      isTagNameBox: true,
      isVoid: true
    },

    madcaptocproxy: {
      group: 'block',
      attrs: {
        'MadCap:autonum': { default: undefined }
      },
      parseDOM: [{
        tag: 'MadCap\\:tocProxy',
        getAttrs(dom: HTMLElement) {
          return getSchemaAttrs(dom, ['MadCap:autonum']);
        }
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:tocProxy',
      isTagNameBox: true,
      isVoid: true
    },

    madcapindexproxy: {
      group: 'block',
      attrs: {
        'MadCap:autonum': { default: undefined }
      },
      parseDOM: [{
        tag: 'MadCap\\:indexProxy',
        getAttrs(dom: HTMLElement) {
          return getSchemaAttrs(dom, ['MadCap:autonum']);
        }
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:indexProxy',
      isTagNameBox: true,
      isVoid: true
    },

    madcaplistofproxy: {
      group: 'block',
      attrs: {
        'MadCap:autonum': { default: undefined }
      },
      parseDOM: [{
        tag: 'MadCap\\:listOfProxy',
        getAttrs(dom: HTMLElement) {
          return getSchemaAttrs(dom, ['MadCap:autonum']);
        }
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:listOfProxy',
      isTagNameBox: true,
      isVoid: true
    },

    madcapconceptsproxy: {
      group: 'block',
      attrs: {
        'MadCap:autonum': { default: undefined }
      },
      parseDOM: [{
        tag: 'MadCap\\:conceptsProxy',
        getAttrs(dom: HTMLElement) {
          return getSchemaAttrs(dom, ['MadCap:autonum']);
        }
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:conceptsProxy',
      isTagNameBox: true,
      isVoid: true
    },

    madcapglossaryproxy: {
      group: 'block',
      attrs: {
        'MadCap:autonum': { default: undefined }
      },
      parseDOM: [{
        tag: 'MadCap\\:glossaryProxy',
        getAttrs(dom: HTMLElement) {
          return getSchemaAttrs(dom, ['MadCap:autonum']);
        }
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:glossaryProxy',
      isTagNameBox: true,
      isVoid: true
    },

    madcaprelationshipsproxy: {
      group: 'block',
      attrs: {
        'MadCap:autonum': { default: undefined }
      },
      parseDOM: [{
        tag: 'MadCap\\:relationshipsProxy',
        getAttrs(dom: HTMLElement) {
          return getSchemaAttrs(dom, ['MadCap:autonum']);
        }
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:relationshipsProxy',
      isTagNameBox: true,
      isVoid: true
    },

    madcapendnotesproxy: {
      group: 'block',
      attrs: {
        'MadCap:autonum': { default: undefined }
      },
      parseDOM: [{
        tag: 'MadCap\\:endnotesProxy',
        getAttrs(dom: HTMLElement) {
          return getSchemaAttrs(dom, ['MadCap:autonum']);
        }
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:endnotesProxy',
      isTagNameBox: true,
      isVoid: true
    },

    madcapsearchbarproxy: {
      group: 'block',
      attrs: {
        'data-mc-skin': { default: undefined }
      },
      parseDOM: [{
        tag: 'MadCap\\:searchBarProxy',
        getAttrs(dom: HTMLElement) {
          return getSchemaAttrs(dom, ['data-mc-skin']);
        }
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:searchBarProxy',
      isTagNameBox: true,
      isVoid: true
    },

    madcapmenuproxy: {
      group: 'block',
      attrs: {
        'data-mc-skin': { default: undefined },
        'mc-linked-toc': { default: undefined },
      },
      parseDOM: [{
        tag: 'MadCap\\:menuProxy',
        getAttrs(dom: HTMLElement) {
          return getSchemaAttrs(dom, ['data-mc-skin', 'mc-linked-toc']);
        }
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:menuProxy',
      isTagNameBox: true,
      isVoid: true
    },

    madcapsearchresultsproxy: {
      group: 'block',
      attrs: {
        'data-mc-skin': { default: undefined }
      },
      parseDOM: [{
        tag: 'MadCap\\:searchResultsProxy',
        getAttrs(dom: HTMLElement) {
          return getSchemaAttrs(dom, ['data-mc-skin']);
        }
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:searchResultsProxy',
      isTagNameBox: true,
      isVoid: true
    },

    madcapelearningtoolbarproxy: {
      group: 'block',
      attrs: {
        'data-mc-skin': { default: undefined }
      },
      parseDOM: [{
        tag: 'MadCap\\:eLearningToolbarProxy',
        getAttrs(dom: HTMLElement) {
          return getSchemaAttrs(dom, ['data-mc-skin']);
        }
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:eLearningToolbarProxy',
      isTagNameBox: true,
      isVoid: true
    },

    madcaptestresultsproxy: {
      group: 'block',
      attrs: {
        'data-mc-skin': { default: undefined }
      },
      parseDOM: [{
        tag: 'MadCap\\:testResultsProxy',
        getAttrs(dom: HTMLElement) {
          return getSchemaAttrs(dom, ['data-mc-skin']);
        }
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:testResultsProxy',
      isTagNameBox: true,
      isVoid: true
    }
  } satisfies Record<string, NodeSpec>;
}
